import styled from 'styled-components';

/**
 * Shared styled components for error pages
 * These components provide consistent styling across all error page types
 */

export const ErrorPageContainer = styled.section.withConfig({
  shouldForwardProp: (prop) => prop !== 'headerHeight',
})`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: ${({ headerHeight }) => `calc(100vh - ${headerHeight}px)`};
  background-color: #f4f6f8;
  color: #212529;
  padding: 2rem;
  text-align: center;
  transition: min-height 0.2s ease-in-out;
`;

export const MessageBox = styled.div`
  background: white;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 2rem 2.5rem;
  max-width: 480px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
`;

export const IconWrapper = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== 'color',
})`
  font-size: 2rem;
  color: ${({ color }) => color || '#faad14'};
  margin-bottom: 1rem;
`;

export const Title = styled.h2`
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: #212529;
`;

export const Description = styled.p.withConfig({
  shouldForwardProp: (prop) => prop !== 'hasAction',
})`
  font-size: 1rem;
  margin-bottom: ${({ hasAction }) => (hasAction ? '1.5rem' : '0')};
  color: #495057;
  line-height: 1.5;
`;

export const ActionLink = styled.a`
  color: #007bff;
  text-decoration: none;
  font-weight: 500;
  transition: all 0.2s ease-in-out;

  &:hover {
    text-decoration: underline;
    color: #0056b3;
  }

  &:focus {
    outline: 2px solid #007bff;
    outline-offset: 2px;
  }
`;

export const FullScreenErrorContainer = styled.div`
  display: grid;
  min-width: 100vw;
  min-height: 100vh;
  line-height: 31px;
  background: rgb(2, 0, 36);
  background: radial-gradient(
    circle,
    rgba(2, 0, 36, 1) 1%,
    rgba(47, 41, 109, 1) 48%,
    rgb(2, 0, 36) 100%
  );
  color: white;
  align-items: center;
  justify-items: center;
`;

export const ErrorDetails = styled.section`
  font-style: italic;
  font-size: 0.7rem;
  margin-top: 0.5rem;
  opacity: 0.8;
`;
